(function () {
    "use strict";

    angular.module("app").controller("ScreeningFvmController", ScreeningFvmController);
    ScreeningFvmController.$inject = [
        "$scope", "$window", "screeningService",
        "notificationService", "settingsService", "FileUploader", "habilBootbox",
        "webApiServices", "enumService", "loadingIndicatorService",
        "infiniteScrollDataSourceFactory", "HabilNavigator", "downloadService",
    ];
    function ScreeningFvmController($scope, $window, screeningService,
        notificationService, settingsService, FileUploader, habilBootbox,
        webApiServices, enumService, loadingIndicatorService,
        infiniteScrollDataSourceFactory, HabilNavigator, downloadService) {

        loadingIndicatorService.SetLoadingState(false);

        $scope.ExportDossiers = exportDossiers;

        $scope.DataSource = null;
        $scope.getScreeningResultTypeFilter = () => $scope.codeScreeningResults && $scope.codeScreeningResults.filter((c) => parseInt(c.Key) > 0);

        $scope.OpenScreening = function (item) {
            const screening = item.Screening;

            screeningService.OpenedScreening = screening;
            $scope.OpenedScreening = screening;
            $scope.OpenedScreeningStatus = screening.Status;

            if (screening.TypeCode === 10) {
                if (item.InitialAction === 11)
                    HabilNavigator.OpenFvmScreening(screening.PublicId, true);
                else HabilNavigator.OpenFvmScreening(screening.PublicId);
            }
            else
                HabilNavigator.OpenIvmScreening(screening.RequestId);
        };

        $scope.SetAsAccepted = function (screening) {
            loadingIndicatorService.SetLoadingState(true);
            screeningService.setAsAccepted(screening.PublicId, updateListAfterChangingStatus, handleError);
        };

        $scope.StopScreening = function (screening) {
            loadingIndicatorService.SetLoadingState(true);
            webApiServices.StopFvmScreenings({ IdStrings: [screening.PublicId] }, updateListAfterChangingStatus, handleError);
        };

        $scope.selectAll = false;
        $scope.ToggleSelectAll = function () {
            $scope.selectAll = !$scope.selectAll;
            if (!$scope.DataSource.Items())
                return;

            $scope.DataSource.Items().filter(g => g.Parent.ShowCheckbox).forEach(g => g.Parent.isSelected = $scope.selectAll);
            $scope.DataSource.Items().flatMap(g => g.Children).filter(s => s.ShowCheckbox).forEach(s => s.isSelected = $scope.selectAll);
        };

        $scope.CanExecuteBulkOperation = hasSelectedScreenings;
        $scope.AreRequestsSelectedForDownloading = hasSelectedScreenings;
        $scope.AreRequestsSelectedForSigning = hasSelectedScreenings;

        $scope.RequestsToSign = function () {
            if (!$scope.DataSource.Items())
                return [];

            return getSelectedScreenings();
        };

        $scope.ConfirmResults = function () {
            const selectedRequests = getSelectedScreenings();

            if (selectedRequests.length === 0)
                return;

            screeningService.Sign({ Type: 'fvm', Items: selectedRequests.map(r => r.Screening) })
                .then(r => authenticateBeforeSigning(r.data))
                .catch(error => DoShowError(notificationService, error));
        };

        function getSelectedScreenings() {
            if (!$scope.DataSource.Items())
                return [];

            const selectedIvms = $scope.DataSource.Items().flatMap(g => g.Children.filter(i => i.isSelected && i.Screening && i.Screening.TypeCode === 20 && i.Screening.Status != enumService.ScreeningStatusCode.ReadOnly));
            const selectedFvms = $scope.DataSource.Items().filter(g => g.Parent.isSelected).map(g => g.Parent);

            return selectedFvms.concat(selectedIvms);
        }

        function hasSelectedScreenings() {
            if (!$scope.DataSource.Items())
                return false;

            return $scope.DataSource.Items().some(g => g.Parent.isSelected) || $scope.DataSource.Items().flatMap(g => g.Children).some(s => s.isSelected && s.Screening);
        }

        $scope.filterToSign = () => isFilteredByState('ToSign');
        $scope.filterToAccept = () => isFilteredByState('ToAccept');

        function isFilteredByState(state) {
            return $window.location.pathname.includes(state);
        }

        $scope.GetExtractSetAccepted = function () {
            if (!$scope.AreRequestsSelectedForDownloading())
                return;

            loadingIndicatorService.SetLoadingState(true);

            const selectedRequests = getSelectedScreenings();

            const data = {
                FvmScreeningIds: selectedRequests.filter(s => s.Screening.TypeCode == 10).map(s => s.Screening.PublicId),
                IvmScreeningIds: selectedRequests.filter(s => s.Screening.TypeCode == 20).map(s => s.Screening.PublicId)
            };
            webApiServices.GetPhaseFilesSetAccepted(data)
                .then(result => {
                    downloadService.SaveResult(result, "habil_extracts.zip");

                    $scope.DataSource.ResetSearch();
                    $scope.OpenedScreening = undefined;
                })
                .catch(e => DoShowError(notificationService, e))
                .finally(() => loadingIndicatorService.SetLoadingState(false));
        };

        $scope.DownloadExtract = downloadExtract;
        function downloadExtract(request) {
            if (!request.Screening)
                return;
            loadingIndicatorService.SetLoadingState(true);

            const screening = request.Screening;

            webApiServices.GetPhaseFile(`id=${screening.PublicId}`)
                .then(downloadService.SaveResult)
                .catch(e => DoShowError(notificationService, e))
                .finally(() => loadingIndicatorService.SetLoadingState(false));
        };

        $scope.ReopenScreening = function (screening) {
            habilBootbox.confirm({
                title: 'Habil+',
                message: $scope.translations.Screening_Question_Reopen,
                size: 'large',
            }).then(reopen, angular.noop);

            function reopen() {
                loadingIndicatorService.SetLoadingState(true);

                webApiServices.ReopenScreeningById(
                    { PublicId: screening.PublicId },
                    (result) => {
                        if (!CheckResultReceived(result)) {
                            DoShowError(notificationService, result);
                            return;
                        }

                        $scope.DataSource.ResetSearch();
                    },
                    (err) => DoShowError(notificationService, err),
                    () => loadingIndicatorService.SetLoadingState(false)
                );
            }
        };

        function getQueryFromUrl() {
            const path = $window.location.pathname.split('/').filter(el => el.length !== 0);
            const pathpiece = path.length - 1;
            return path[pathpiece].toLowerCase();
        }

        function setCheckboxStates(items) {
            if (!items) return;

            if (isFilteredByState('ToAccept') || isFilteredByState("Revisions")) {
                items.forEach(g => {
                    if (g && g.Parent && g.Parent.Screening && g.Parent.Screening.Status === '10')
                        g.Parent.ShowCheckbox = true;
                    else
                        g.Children.forEach(c => {
                            if (c.Screening && c.Screening.Status === '10')
                                c.ShowCheckbox = true;
                        });
                });
            }

            if (isFilteredByState('ToSign')) {
                items.forEach(g => {
                    g.Parent.ShowCheckbox = true;
                });
            }

            if (isFilteredByState('ToReturn')) {
                items.forEach(g => {
                    g.Parent.ShowCheckbox = isScreeningWaitingForReturnToNVO(g.Parent.Screening);
                    if (!g.Parent.ShowCheckbox)
                        g.Children.forEach(s => s.ShowCheckbox = isScreeningWaitingForReturnToNVO(s.Screening));
                });
            }
        }

        function isScreeningWaitingForReturnToNVO(screening) {
            return screening && screening.ResultCode === '20' && screening.Status === '20';
        }

        function Start() {
            $scope.action = getQueryFromUrl();
            $scope.DataSource = infiniteScrollDataSourceFactory.Create(
                webApiServices.SearchMyFvmScreening,
                (v) => $scope.isLoadingRequests = v,
                setCheckboxStates
            );

            const toSearch = ['toaccept', 'toanswer', 'tosign', 'toreturn', 'rejected', 'tostop', 'stoppedscreenings', 'revisions'];
            const found = toSearch.find(a => a === $scope.action);

            if (found) {
                $scope.DataSource.GetFilter().BaseQuery = $scope.action;

                if ($scope.action === "revisions") {
                    $scope.DataSource.GetFilter().ScreeningQueryFilterTypes = 2; // Revision
                }
            }

            $scope.DataSource.ResetSearch();
        }

        // TODO: Implement and use a FileUploaderFactory service
        $scope.uploadScreeningResultsController = function ($scope) {
            const uploader = $scope.uploader = new FileUploader({
                url: settingsService.applicationPath + 'api/UploadScreeningResults/invoke',
                removeAfterUpload: true,
                queueLimit: 10
            });

            // FILTERS
            uploader.filters.push({
                name: 'customFilter',
                fn: function (item) {
                    const type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return '|json|'.indexOf(type) !== -1;
                }
            });

            uploader.onAfterAddingAll = function () {
                loadingIndicatorService.SetLoadingState(true);

                uploader.uploadAll();
            };
            uploader.onErrorItem = function (_fileItem, response) {
                handleError(response);
            };
            uploader.onCompleteAll = function () {
                loadingIndicatorService.SetLoadingState(false);

                $scope.DataSource.ResetSearch();
            };
        };
        $scope.uploadScreeningResultsController.$inject = ['$scope'];

        $scope.ConfirmRejectedScreenings = confirmRejectedScreenings;
        function confirmRejectedScreenings() {
            const selectedRequests = getSelectedScreenings();

            if (selectedRequests.length === 0)
                return;

            screeningService.Sign({ Type: 'fvm-return', Items: selectedRequests.map(r => r.Screening) })
                .then(r => authenticateBeforeSigning(r.data))
                .catch(error => DoShowError(notificationService, error));
        }

        Start();

        /**
         * Checks if the API call succeeded and prompts the user to authenticate themselves using their eId
         * @param {Object} result the result from an API call
         */
        function authenticateBeforeSigning(result) {
            if (!CheckResultReceived(result)) {
                DoShowError(notificationService, result);
                return;
            }

            const options = {
                onEscape: true,
                closeButton: true,
                title: $scope.translations.GetFasRedirectionTitle,
                templateUrl: settingsService.applicationPath + 'Account/ChangeFASLogin?returnurl=' + encodeURIComponent($window.location.pathname + $window.location.search)
            };
            habilBootbox.customDialog(options);
        }

        /**
         * Checks if the API call succeeded and updates the list of screenings when the action succeeded
         * @param {Object} result the result from an API call 
         */
        function updateListAfterChangingStatus(result) {
            if (CheckResultReceived(result)) {
                const index = $scope.DataSource.Items().indexOf(result.data);
                $scope.DataSource.Items().splice(index, 1);
            }
            else { DoShowError(notificationService, result); }
            loadingIndicatorService.SetLoadingState(false);
        }

        function handleError(error) {
            DoShowError(notificationService, error);
            loadingIndicatorService.SetLoadingState(false);
        }

        $scope.LoadedItems = function () {
            if (!$scope.DataSource || $scope.isLoadingRequests)
                return 0;

            const items = $scope.DataSource.Items();

            const status = $scope.DataSource.GetFilter().Status;
            const flattened = items.map(r => r.Parent).concat(items.flatMap(r => r.Children));

            return flattened.reduce((acc, request) => {
                if (request && request.Screening)
                    return request.Screening.Status === status ? ++acc : acc;
                return acc;
            }, 0);
        };

        function exportDossiers() {
            loadingIndicatorService.SetLoadingState(true);

            const filter = $scope.DataSource.GetFilter();

            webApiServices.FscScreeningsExporting(
                { Filter: filter },
                downloadService.saveExport,
                error => DoShowError(notificationService, error),
                () => loadingIndicatorService.SetLoadingState(false)
            );
        }
    }
})();
